module.exports = __webpack_public_path__ + "static/img/6.cb64904.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/6.png
// module id = xxDe
// module chunks = 0